import { useState } from "react";

export const useAsyncSubmit = (setError: (message: string) => void) => {
  const [submitting, setSubmitting] = useState(false);

  const wrapSubmit =
    <T>(fn: (values: T) => Promise<void>) =>
    async (values: T) => {
      setSubmitting(true);
      setError("");
      try {
        await fn(values);
      } finally {
        setSubmitting(false);
      }
    };

  return { submitting, wrapSubmit };
};
